// <s-recently-viewed> remembers product handles in localStorage and renders the last few viewed
// products (excluding the current one) from /products/<handle>.js using the <template data-card>.
// The whole section stays hidden until at least one product is available.
const STORAGE_KEY = 'veriazione:recently-viewed';
const MAX_STORED = 8;

class SRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const current = this.dataset.currentHandle;
    const limit = Number(this.dataset.limit || 4);
    let handles = [];
    try {
      handles = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
      handles = [];
    }
    const toShow = handles.filter((handle) => handle !== current).slice(0, limit);
    if (current) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify([current, ...handles.filter((h) => h !== current)].slice(0, MAX_STORED)));
      } catch {}
    }
    if (!toShow.length) return;

    const root = window.Shopify?.routes?.root || '/';
    const results = await Promise.all(
      toShow.map((handle) =>
        fetch(`${root}products/${encodeURIComponent(handle)}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      )
    );
    const products = results.filter((product) => product && product.available !== undefined);
    if (!products.length) return;

    const template = this.querySelector('template[data-card]');
    const list = this.querySelector('[data-list]');
    if (!template || !list) return;
    const money = new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: this.dataset.currency || 'USD',
    });

    for (const product of products) {
      const card = template.content.firstElementChild.cloneNode(true);
      const media = product.media?.[0];
      const image = card.querySelector('img');
      if (image && product.featured_image) {
        const url = new URL(product.featured_image, window.location.origin);
        url.searchParams.set('width', '600');
        image.src = url.toString();
        image.alt = product.title;
        if (media?.width && media?.height) {
          image.width = media.width;
          image.height = media.height;
        }
      } else {
        image?.remove();
      }
      for (const link of card.querySelectorAll('a')) link.href = product.url;
      card.querySelector('[data-title]').textContent = product.title;
      card.querySelector('[data-price]').textContent = money.format(product.price / 100);
      const soldOut = card.querySelector('[data-sold-out]');
      if (soldOut) soldOut.hidden = product.available;
      list.append(card);
    }
    this.hidden = false;
  }
}

if (!customElements.get('s-recently-viewed')) customElements.define('s-recently-viewed', SRecentlyViewed);
